module.exports = __webpack_public_path__ + "static/media/IMG_20190616_125308.744dc2c4.jpg";